import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/apps/product-plus/search-domain/pipelines/positive-ev/response-factory';
import { type TrendsSearchResponseBody } from '~/apps/product-plus/search-domain/pipelines/trends/types';
import { type SearchDomainContext, type SearchPipelineEnrichments } from '~/apps/product-plus/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/apps/product-plus/search-domain/utils';

export async function transformTrendsResponse(
  context: SearchDomainContext,
  {
    enrichments,
    searchRequest,
    searchResponse,
  }: {
    enrichments?: SearchPipelineEnrichments;
    searchRequest: SearchRequest;
    searchResponse: TrendsSearchResponseBody;
  },
) {
  const hitsPerPage = searchRequest?.request?.params?.hitsPerPage ?? 10;
  const page = searchRequest?.request?.params?.page ?? 0;
  const from = page * hitsPerPage;

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(
    createResponseFactoryContext(context),
    elasticContext,
    searchResponse,
    from,
    hitsPerPage,
    enrichments?.bookmakerCountsByBetId,
  );
}
